import { useEffect } from 'react';
import { useStore } from './useRootStore';

export const useAppPreloader = (show: boolean, type = 'outside', size = 'big'): void => {
  const {
    appPreloaderStore: { setPreloaderState },
  } = useStore();
  useEffect(() => {
    setPreloaderState(show, type, size);
  }, [show, type, size, setPreloaderState]);
};
